import React from 'react';
import { Box } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import { SelectChangeEvent } from '@mui/material/Select';
import { utils } from '@rjsf/core';
import { Select } from '../../stories/Select';
import { CustomWidgetProps } from '../types';

const SelectWidget = ({
  id,
  options = {},
  label,
  disabled,
  readonly,
  value,
  onChange,
  onBlur,
  onFocus,
  schema,
  uiSchema,
  formContext: { onHasChanged },
}: CustomWidgetProps): JSX.Element => {
  const { enumOptions, emptyValue = '' } = options;

  const _onChange = (event: SelectChangeEvent<unknown>) => {
    const value = event.target.value;
    if (typeof value === 'string') {
      onChange(value === '' ? emptyValue : value);
      setTimeout(() => onHasChanged?.({ id, value }), 0);
    }
  };
  const _onBlur = ({ target: { value } }: React.FocusEvent<HTMLInputElement>) => onBlur(id, value);
  const _onFocus = ({ target: { value } }: React.FocusEvent<HTMLInputElement>) => onFocus(id, value);
  const displayLabel = utils.getDisplayLabel(schema, uiSchema);

  return (
    <Box
      sx={{
        '& .select-widget': {
          border: '1px solid #D5D7DA',
        },
      }}
    >
      <Select
        className="select-widget"
        id={id}
        data-testid="select-widget"
        label={displayLabel ? label || schema.title : ''}
        value={typeof value === 'undefined' ? emptyValue : value}
        disabled={disabled}
        readOnly={readonly}
        onChange={_onChange}
        onBlur={_onBlur}
        onFocus={_onFocus}
        slotProps={{
          input: {
            'aria-label': displayLabel ? label || schema.title : '',
          },
        }}
        fullWidth
      >
        {(enumOptions as Array<{ value: string; label: string }>).map(({ value, label }) => {
          return (
            <MenuItem key={value} value={value} disabled={disabled || readonly}>
              {label}
            </MenuItem>
          );
        })}
      </Select>
    </Box>
  );
};

export default SelectWidget;
